
import { Component, Vue } from "vue-property-decorator";
import Input from "./components/Input.vue";
import Radio from "./components/Radio.vue";
import Checkbox from "./components/Checkbox.vue";
import Select from "./components/Select.vue";
import Datepicker from "./components/Datepicker.vue";
import Autocomplete from "./components/Autocomplete.vue";
import Textarea from "./components/Textarea.vue";
import Switch from "./components/Switch.vue";
import Postcode from "./components/Postcode.vue";
import Multiselect from "./components/Multiselect.vue";
import JobSearch from "./components/JobSearch.vue";
import JobTitleSelect from "./components/JobTitleSelect.vue";
import BandSelect from "./components/BandSelect.vue";
import CompaniesHouseAutocomplete from "./components/CompaniesHouseAutocomplete.vue";
import ProvideDataSelect from "./components/ProvidedDataSelect.vue";
import EmployeeMultiselect from "./components/EmployeeMultiselect.vue";
import NoneOfTheAbove from "./components/NoneOfTheAbove.vue";

import { SMQuestionnaire } from "@/store";

const TYPE_POSTCODE = "postcode";

@Component
export default class AnswerBlocks extends Vue {
  get answerBlocks() {
    return SMQuestionnaire.currentStep?.question.answer_blocks ?? [];
  }

  get filteredAnswerBlocks() {
    return this.answerBlocks.filter((answerBlock) => this.isVisible(answerBlock.ID));
  }

  answerBlockTypes = {
    input: Input,
    radio: Radio,
    checkbox: Checkbox,
    select: Select,
    date: Datepicker,
    autocomplete: Autocomplete,
    textarea: Textarea,
    switcher: Switch,
    postcode: Postcode,
    multiselect: Multiselect,
    ["job-search"]: JobSearch,
    ["job-title-select"]: JobTitleSelect,
    ["band-select"]: BandSelect,
    ["companies-house-autocomplete"]: CompaniesHouseAutocomplete,
    ["provided-data-select"]: ProvideDataSelect,
    ["employee-multiselect"]: EmployeeMultiselect,
    ["none-of-the-above"]: NoneOfTheAbove,
    "": null,
  };

  loopIndex = 0;

  isVisible(id: number) {
    const condition = SMQuestionnaire.conditions.find(
      (condition) => condition.target_id == id && condition.answer_block_alias !== condition.value
    );

    if (!condition) return true;

    return !!SMQuestionnaire.conditions.filter((condition) => {
      return SMQuestionnaire.answers.some(
        (answer) =>
          answer.value === condition.value &&
          condition.target_id === id &&
          condition.visible === true
      );
    }).length;
  }

  componentKey = 0;

  getComponentKey(type: string, id: number) {
    const componentKey = `${id}_${this.componentKey}`;

    if (type !== TYPE_POSTCODE) return componentKey;

    return id;
  }

  updateComponentKey() {
    this.componentKey += 1;
  }

  get disabled() {
    return SMQuestionnaire.isNoneOfTheAboveOptionSelected;
  }

  get hasNoneOfTheAboveAnswerBlock() {
    return SMQuestionnaire.hasNoneOfTheAboveAnswerBlock;
  }
}
